import React from 'react';

import GeneralSuite from '../../../components/GeneralSuite';

import img1 from '../../../images/Rooms/green/1.jpg';
import img2 from '../../../images/Rooms/green/2.jpg';
import img3 from '../../../images/Rooms/green/3.jpg';
import img4 from '../../../images/Rooms/green/4.jpg';
import img5 from '../../../images/Rooms/green/5.jpg';
import img6 from '../../../images/Rooms/green/6.jpg';
import FancyButton from '../../../components/FancyButton';

const Green = (props) => {
  return (
    <GeneralSuite
      Heading={"Green House Suite"}
      Description={"Room Description"}
      width={"100px"}
      SupportImages={[img1, img2, img3, img4, img5, img6]}
      DescriptionContent={() => <React.Fragment>
        <div style={{ fontSize: '1.4rem', lineHeight: '2rem' }}>
          Our Green-House Family Suite offers the perfect blend of luxury, privacy and comfort, designed with
          the needs of modern families or friends travelling together. With private access and the flexibility of
          two inter-connecting rooms, this suite allows you to enjoy both togetherness and personal space,
          making it an ideal choice for families or groups seeking a truly relaxing getaway.
        </div> <br />
        <div style={{ fontSize: '1.4rem', lineHeight: '2rem' }}>
          Step outside to your private sit-out patio, a tranquil outdoor space where you can enjoy a quiet
          morning coffee or an evening cocktail amidst the natural beauty of the surrounding greenery. The
          exteriors of the suite are beautifully adorned with vibrant green ivy, providing a peaceful and
          refreshing atmosphere.
        </div> <br />
        <div
          style={{ display: 'flex', marginTop: '2rem' }}
        >
          <a href="https://bookings.hotelhilltone.com/?propertyId=8826">
            <FancyButton style={{ margin: '1rem 0' }} text="Book a Stay" />
          </a>
        </div>
      </React.Fragment>}
      backFlag={true}
      roomType={"rock"}
      {...props}
    />
  );
}

export default Green;